import Seo from "@/components/Seo";
import CaseStudiesSection from "@/components/sections/CaseStudiesSection";
import Stats from "@/components/sections/Stats";
import CTABand from "@/components/sections/CTABand";

export default function CaseStudies() {
  return (
    <div data-testid="case-studies-page">
      <Seo
        title="Études de cas"
        description="Découvrez nos réalisations : MBOA SEND, MBOA ZICK, DEMKABIZ, MBOA WALLET — fintech, IA musicale, services pros, crypto."
        path="/realisations"
      />
      <section className="bg-white pt-16 pb-4">
        <div className="mx-auto max-w-7xl px-6 md:px-10">
          <div className="text-[#00B8D9] text-xs tracking-[0.2em] uppercase font-bold mb-3">Études de cas</div>
          <h1 className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl text-[#0B1F3A] tracking-tighter max-w-3xl text-balance">
            Des projets qui <span className="text-[#00B8D9]">livrent des résultats</span>
          </h1>
          <p className="mt-5 text-lg text-[#4B5563] max-w-2xl">
            Découvrez les plateformes que nous avons conçues, développées et fait grandir.
          </p>
        </div>
      </section>
      <CaseStudiesSection />
      <Stats />
      <CTABand />
    </div>
  );
}
